export default {
	playlistById: (id: string) => `/playlist/${id}`,
	playlistFans: (id: string) => `/playlist/${id}/fans`,
	filtersPlaylistArtists: '/playlist-report/filters/artists',
	filtersPlaylistSegmentations: '/playlist-report/filters/editor-segmentation',
	filtersPlaylistNames: '/playlist-report/filters/playlists',
	report: '/playlist-report',
	reportExport: '/playlist-report/export',
};
